module.exports = __webpack_public_path__ + "assets/img/featured-2.120f562a.jpg";